var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14.9935C9.99649 12.2351 7.75926 10 5.00001 10C2.23858 10 8.53638e-06 12.2386 8.53638e-06 15C8.53638e-06 17.7614 2.23858 20 5.00001 20C7.75926 20 9.99649 17.7649 10 15.0065C10.0035 17.7649 12.2407 20 15 20C17.7614 20 20 17.7614 20 15C20 12.2386 17.7614 10 15 10C12.2407 10 10.0035 12.2351 10 14.9935Z",
    fill: "#FFF848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10 2.23857 12.2386 0 15 0C17.7614 0 20 2.23857 20 5C20 7.76142 17.7614 10 15 10C12.2386 10 10 7.76142 10 5Z",
    fill: "#FFF848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10 7.76142 7.76143 10 5.00001 10C2.23858 10 0 7.76142 0 5C0 2.23857 2.23858 0 5 0C7.76142 0 10 2.23857 10 5Z",
    fill: "#FFF848"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.bef4cb2dce9adcb9f42f0b47d981a63e.svg";
export { ForwardRef as ReactComponent };